import React, {useLayoutEffect, useState} from 'react';
import {useHistory} from 'react-router-dom';
import {Router} from 'react-router';

export {Link, NavLink, useLocation, useNavigate} from 'react-router';

// Keep the existing v5 route matching and history while moving modern links
// and navigation hooks onto the patched v7 implementation.
export function CompatRouter({children}) {
    const history = useHistory();
    const [state, setState] = useState(() => ({
        location: history.location,
        action: history.action,
    }));

    useLayoutEffect(() => history.listen((location, action) => {
        setState({location, action});
    }), [history]);

    return (
        <Router location={state.location} navigationType={state.action} navigator={history}>
            {children}
        </Router>
    );
}
